import { motion } from "framer-motion";
import { Compass, Plane, Bus, ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/siteData";

const ICONS = { holidays: Compass, flights: Plane, bus: Bus };

export const Services = ({ onEnquire }) => {
  return (
    <section id="services" className="relative py-28 lg:py-36" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-2xl"
        >
          <p className="text-teal-300 tracking-[0.3em] text-xs uppercase mb-4">What we do</p>
          <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight">
            Three crafts, <span className="italic text-teal-300">one promise</span> — travel without friction.
          </h2>
        </motion.div>

        <div className="mt-16 grid gap-8 md:grid-cols-3">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.id];
            return (
              <motion.article
                key={s.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
                className="group spotlight-card rounded-2xl border border-teal-500/15 bg-[#1C2541]/60 backdrop-blur-sm overflow-hidden transition-colors duration-500 hover:border-teal-400/40"
                data-testid={`service-card-${s.id}`}
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1C2541] to-transparent" />
                  <div className="absolute bottom-4 left-4 flex h-11 w-11 items-center justify-center rounded-full bg-[#0B132B]/80 border border-teal-400/30 backdrop-blur">
                    <Icon className="w-5 h-5 text-teal-300" />
                  </div>
                </div>
                <div className="p-7">
                  <h3 className="font-serif text-xl sm:text-2xl">{s.title}</h3>
                  <p className="mt-3 text-sm text-slate-400 leading-relaxed">{s.description}</p>
                  <button
                    onClick={() => onEnquire(s.title)}
                    data-testid={`service-enquire-btn-${s.id}`}
                    className="mt-6 inline-flex items-center gap-2 text-sm text-teal-300 hover:text-teal-200 transition-colors"
                  >
                    Enquire Now
                    <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                  </button>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
